import React, {useRef, useState} from "react";
import {Modal} from "react-bootstrap";

const ConsultReportCrudLoad = ({onLoad}) => {
    const [show, setShow] = useState(false);
    const [jsonText, setJsonText] = useState("");
    const [nombreArchivo, setNombreArchivo] = useState("Ningún archivo elegido");
    const [error, setError] = useState("");
    const fileInputRef = useRef();

    const abrir = () => {
        setError("");
        setShow(true);
    }
    const cerrar = () => setShow(false);

    const elegirArchivo = () => fileInputRef.current.click();

    const handleArchivo = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        if (!file.name.toLowerCase().endsWith(".json")) {
            setError("Elige un archivo con extensión .json.");
            return;
        }
        setError("");
        setNombreArchivo(file.name);
        const reader = new FileReader();
        reader.onload = () => setJsonText(reader.result);
        reader.onerror = () => setError("No se pudo leer el archivo.");
        reader.readAsText(file, "utf-8");
    }

    const aplicar = () => {
        let data;
        try {
            data = JSON.parse(jsonText);
        } catch (err) {
            setError("No se pudo leer el JSON: " + err.message);
            return;
        }
        if (!Array.isArray(data.reporte)) {
            setError('El JSON debe traer un arreglo "reporte".');
            return;
        }
        onLoad(data);
        setShow(false);
    }
    const limpiar = () => {
        setJsonText("");
        setNombreArchivo("");
        setError("");
    }

    return (
        <>
            <button type="button" className="btn btn-outline-secondary btn-sm" onClick={abrir}>
                Cargar respuesta
            </button>
            <Modal show={show} onHide={cerrar}>
                <Modal.Header closeButton>
                    <Modal.Title>Cargar respuesta del servicio</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="text-muted small">
                        Pega el JSON completo (con success, count y reporte) o carga un archivo .json.
                    </p>
                    <div className="d-flex align-items-center gap-2 mb-2">
                        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={elegirArchivo}>
                            Elegir archivo .json
                        </button>
                        <span className="text-muted small">{nombreArchivo}</span>
                        <input
                            type="file"
                            accept="application/json,.json"
                            ref={fileInputRef}
                            onChange={handleArchivo}
                            hidden
                        />
                    </div>
                    <textarea
                        className="form-control"
                        rows={10}
                        value={jsonText}
                        onChange={(e) => setJsonText(e.target.value)}
                        spellCheck={false}
                    />
                    {error && <div className="text-danger small mt-2">{error}</div>}
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-outline-secondary" onClick={cerrar}>Cancelar</button>
                    <button type="button" className="btn btn-primary" onClick={aplicar}>Mostrar reporte</button>
                    <button type="button" className="btn btn-danger" onClick={limpiar}>Limpiar</button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default ConsultReportCrudLoad;